import { PlannerApi } from '../planner.api';
import type { ApiResponse, PlannerTask } from '@vision/ui/interfaces';
import type {
  PlannerTasksArgs,
  PlannerTaskCreateArgs,
  PlannerTaskUpdateArgs,
  PlannerTaskAttachmentDeleteArgs,
  PlannerTaskAttachmentCreateArgs,
  PlannerTaskSearchArgs,
  PlannerTaskDetailArgs,
} from './tasks.api.types';
import {
  buildGetDashboardTasksRequest,
  buildCreateTaskRequest,
  buildUpdateTaskRequest,
  buildDeleteAttachmentRequest,
  buildCreateTaskAttachmentRequest,
  buildSearchTasksRequest,
  buildShowTaskRequest,
} from './tasks.routes';
import { fromApiPlannerTaskResponse, fromApiPlannerTasksResponse } from './tasks.mappers';

export const PlannerTaskEndpoints = PlannerApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardTasks: builder.query<ApiResponse<PlannerTask[]>, PlannerTasksArgs>({
      transformResponse: fromApiPlannerTasksResponse,
      query: buildGetDashboardTasksRequest,
      providesTags: (result, error, arg) => [{ type: 'Dashboard', id: arg.dashboardId }, 'Planner'],
    }),
    createTask: builder.mutation<ApiResponse<PlannerTask>, PlannerTaskCreateArgs>({
      transformResponse: fromApiPlannerTaskResponse,
      query: buildCreateTaskRequest,
      invalidatesTags: (result, error, arg) => [{ type: 'Dashboard', id: arg.dashboardId }],
    }),
    updateTask: builder.mutation<ApiResponse<PlannerTask>, PlannerTaskUpdateArgs>({
      transformResponse: fromApiPlannerTaskResponse,
      query: buildUpdateTaskRequest,
    }),
    deleteAttachment: builder.mutation<void, PlannerTaskAttachmentDeleteArgs>({
      query: buildDeleteAttachmentRequest,
    }),
    createTaskAttachment: builder.mutation<ApiResponse<PlannerTask>, PlannerTaskAttachmentCreateArgs>({
      query: buildCreateTaskAttachmentRequest,
    }),
    searchTasks: builder.query<ApiResponse<PlannerTask[]>, PlannerTaskSearchArgs>({
      transformResponse: fromApiPlannerTasksResponse,
      query: buildSearchTasksRequest,
    }),
    showTask: builder.query<ApiResponse<PlannerTask>, PlannerTaskDetailArgs>({
      transformResponse: fromApiPlannerTaskResponse,
      query: buildShowTaskRequest,
      providesTags: (result, error, arg) => [{ type: 'Task', id: arg.taskId }],
    }),
  }),
});

export const {
  useLazyGetDashboardTasksQuery,
  useCreateTaskMutation,
  useUpdateTaskMutation,
  useDeleteAttachmentMutation,
  useCreateTaskAttachmentMutation,
  useLazySearchTasksQuery,
  useLazyShowTaskQuery,
} = PlannerTaskEndpoints;
